import React, { FC } from 'react';
import { RefundPricesFragment } from '@websky/graphql';
import cn from 'classnames';
import { Money as MoneyType } from '../../../../../types';
import Details from './components/Details/Details';
import { ExchangeRefundPriceDetailsVariant } from '../../model';
import ShortDetails from './components/ShortDetails/ShortDetails';
import TotalRefund from './components/TotalRefund/TotalRefund';
import { useTheme } from '../../../../../theme';
import { CheckinCard } from '@shared/CheckinCard';
import { Props as PriceItemProps } from './components/PriceItem/PriceItem';

export interface Props {
	className?: string;
	additionalPrices?: PriceItemProps[];
	prices: RefundPricesFragment;
	ticketPrice?: MoneyType;
	variant?: ExchangeRefundPriceDetailsVariant;
}

const ExchangeRefundPriceDetails: FC<Props> = ({
	className,
	prices,
	variant = 'details',
	ticketPrice,
	additionalPrices
}) => {
	const { ExchangeRefundPriceDetails: theme } = useTheme('Entities').Order.ExchangeRefundPriceDetails;

	return (
		<CheckinCard className={cn(theme.root, className)}>
			{variant === 'details' && <Details prices={prices} additionalPrices={additionalPrices} />}
			{variant === 'short-details' && <ShortDetails prices={prices} ticketPrice={ticketPrice} />}
			{variant === 'only-total' && <TotalRefund price={prices.priceToPay} />}
		</CheckinCard>
	);
};

export default ExchangeRefundPriceDetails;
